import type {LogsGlobal} from '@datadog/browser-logs';
import {RumGlobal} from '@datadog/browser-rum';
import {createContext, useContext, useEffect} from 'react';

import {getDatadogLogs, getDatadogRum} from './wrapper';

type DatadogContextValue = {
  rum: RumGlobal;
  logs: LogsGlobal;
};

export const DatadogContext = createContext<DatadogContextValue>({
  rum: getDatadogRum(),
  logs: getDatadogLogs(),
});

export function useDatadog(): DatadogContextValue {
  return useContext(DatadogContext);
}

export function useDatadogRum() {
  return useDatadog().rum;
}

export function useDatadogLogs() {
  return useDatadog().logs;
}

export function useGlobalRumContext(key: string, value: unknown) {
  const datadogRum = useDatadogRum();

  useEffect(() => {
    datadogRum.setGlobalContextProperty(key, value);
    return () => {
      datadogRum.removeGlobalContextProperty(key);
    };
  }, [datadogRum, key, value]);
}
